import classNames from "classnames/bind";
import React from "react";

import { COLORS } from "../../component.constants";
import Close from "../../icons/close-icon";
import styles from "./form-overlay.module.scss";

const cx = classNames.bind(styles);

export type FormProps = {
    headerText?: string;
    body?: React.ReactNode;
    footer?: React.ReactNode;
    active?: boolean;
    setFadeOut: () => void;
};

const FormOverlay: React.FC<FormProps> = ({
    headerText,
    body,
    footer,
    active = true,
    setFadeOut,
}) => {
    const formClassName = cx("container", {
        [styles.inactiveContainer]: !active,
        [styles.activeContainer]: active,
    });

    const overlayClassName = cx("overlay", {
        [styles.activeOverlay]: active,
        [styles.inactiveOverlay]: !active,
    });

    return (
        <>
            <div onClick={setFadeOut} className={overlayClassName}></div>
            <div className={formClassName}>
                <div className={styles.header}>
                    {headerText && <h3>{headerText}</h3>}
                    <div onClick={setFadeOut} className={styles.iconContainer}>
                        <Close color={COLORS.black} width={30} height={30} />
                    </div>
                </div>

                <div className={styles.body}>{body}</div>
                <div className={styles.footer}>{footer}</div>
            </div>
        </>
    );
};

export default FormOverlay;
